import { FC } from "react";

import { usePreviewContext } from "../../LiveFormEditor/LivePreview/context/PreviewContext";

import { ThemedOrganizationLogoAndNameBlock } from "@/features/FormV2/sharedComponents/ThemedOrganizationLogoAndNameBlock";

type FormV2LogoChipProps = {
  organizationName: string | null | undefined;
  logoUrl: string | undefined | null;
};

export const FormV2LogoChip: FC<FormV2LogoChipProps> = ({ organizationName, logoUrl }) => {
  const { isPreview, placeholders } = usePreviewContext();

  return (
    <ThemedOrganizationLogoAndNameBlock
      name={organizationName ?? ""}
      logoSrc={logoUrl ?? undefined}
      withFallbackImage={isPreview && placeholders.isLogo}
    />
  );
};
